import React from 'react'
import IncomeAttributeLookupObject from '../../types/lookups/IncomeAttributeLookupObject';
import IncomeAttributeTableFragmentGenerator from '../../utils/TableGenerator/IncomeAttributeTableFragmentGenerator';

export interface CapitalCostsSummaryTabProps {
  handleCurrencyChange: (newAmt: number | undefined | null, name: string, oldAmt: number | undefined | null) => void,
  handleCommentChange: (value: string, name: string) => void,
  lookups: IncomeAttributeLookupObject[],
  name: string,
  incomeAttributes?: Record<string, unknown>[],
  lookupType: string;
  errors?: Record<string, string>
}

function CapitalCostsSummaryTab(props: CapitalCostsSummaryTabProps) {
    const { handleCommentChange, handleCurrencyChange, lookups } = props
    return (
        <>
            {lookups && 
                <table className="table-with-border pie-table" role="presentation">
                    <tbody>
                        {
                            lookups.map((attr, key) => {
                                let incomeAttributesData: Record<string, unknown> | undefined = undefined;
                                if (props.incomeAttributes) {
                                incomeAttributesData = props.incomeAttributes.find(({ code }) => code === attr.incomeAttributeCode);
                                }

                                if (attr.incomeAttributeCode === '120') {
                                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                        data={incomeAttributesData}
                                        showSubheading={false} hasInputLabel={true} isOtherLabel={false}
                                        handleCommentChange={handleCommentChange}
                                        valueChangeHandler={handleCurrencyChange}
                                        isRequiredField={true}
                                        isCapitalCostsOrReplacementReserve={true} />
                                } else if (attr.incomeAttributeCode === '129' || attr.incomeAttributeCode === '133') {
                                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                        data={incomeAttributesData}
                                        showSubheading={false} hasInputLabel={true} isOtherLabel={false}
                                        handleCommentChange={handleCommentChange}
                                        valueChangeHandler={handleCurrencyChange}
                                        isRequiredField={false}
                                        isCapitalCostsOrReplacementReserve={true} />
                                } else {
                                    return <IncomeAttributeTableFragmentGenerator key={key} attribute={attr}
                                        data={incomeAttributesData}
                                        showSubheading={false} hasInputLabel={false} isOtherLabel={false}
                                        handleCommentChange={handleCommentChange}
                                        valueChangeHandler={handleCurrencyChange}
                                        isRequiredField={false}
                                        isCapitalCostsOrReplacementReserve={true} />
                                }
                                
                            })
                        }
                    </tbody>
                </table>
            }
        </>
    )
}

export default CapitalCostsSummaryTab